import { createSlice } from '@reduxjs/toolkit';
import errorWrapper from '~/redux/reducers/utils/errorWrapper';
import * as actions from './actions';
const comparisonSlice = createSlice({
    name: 'comparisons',
    initialState: {
        creatingDocumentComparison: false,
        areComparisonDocumentsLoading: false,
        isFetchingComparisonDocPdfs: false,
        postingComment: false,
        deletingCommentId: undefined,
        comparisonDocuments: [],
        documentComparisonId: undefined,
        isExportingComparison: false,
    },
    reducers: {
        setIsExportingComparison: (state, action) => {
            state.isExportingComparison = action.payload;
        },
        setComparisonDocuments: (state, action) => {
            state.comparisonDocuments = action.payload;
        },
        setDocumentComparisonId: (state, action) => {
            state.documentComparisonId = action.payload;
        },
    },
    extraReducers: {
        [actions.getOrCreateDocumentComparison.pending]: (state) => {
            state.creatingDocumentComparison = true;
        },
        [actions.getOrCreateDocumentComparison.fulfilled]: (state) => {
            state.creatingDocumentComparison = false;
        },
        [actions.getOrCreateDocumentComparison.rejected]: (state, action) => {
            var _a;
            state.creatingDocumentComparison = false;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
        [actions.getComparisonDocumentsById.pending]: (state) => {
            state.comparisonDocuments = [];
            state.areComparisonDocumentsLoading = true;
        },
        [actions.getComparisonDocumentsById.fulfilled]: (state, action) => {
            state.comparisonDocuments = action.payload.comparisonDocuments;
            state.documentComparisonId = action.payload.documentComparisonId;
            state.areComparisonDocumentsLoading = false;
        },
        [actions.getComparisonDocumentsById.rejected]: (state, action) => {
            var _a;
            state.areComparisonDocumentsLoading = false;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
        [actions.fetchComparisonPdfs.pending]: (state) => {
            state.isFetchingComparisonDocPdfs = true;
        },
        [actions.fetchComparisonPdfs.fulfilled]: (state, action) => {
            state.isFetchingComparisonDocPdfs = false;
            state.comparisonDocuments = action.payload.comparisonDocuments;
        },
        [actions.fetchComparisonPdfs.rejected]: (state, action) => {
            var _a;
            state.isFetchingComparisonDocPdfs = false;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
        [actions.addComment.pending]: (state) => {
            state.addingComment = true;
        },
        [actions.addComment.fulfilled]: (state, action) => {
            const { classificationId } = action.meta.arg;
            const comparisonDocuments = [...state.comparisonDocuments];
            for (const doc of comparisonDocuments) {
                const foundClassification = doc.classifications.find(classification => {
                    return classification.id === classificationId;
                });
                if (foundClassification) {
                    foundClassification.comments = [...action.payload];
                    break;
                }
            }
            state.comparisonDocuments = comparisonDocuments;
            state.addingComment = false;
        },
        [actions.addComment.rejected]: (state, action) => {
            var _a;
            state.addingComment = false;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
        [actions.deleteComment.pending]: (state, action) => {
            const { commentId } = action.meta.arg;
            state.deletingCommentId = commentId !== null && commentId !== void 0 ? commentId : undefined;
        },
        [actions.deleteComment.fulfilled]: (state, action) => {
            const { commentId } = action.meta.arg;
            const comparisonDocuments = [...state.comparisonDocuments];
            comparisonDocuments.forEach(doc => {
                doc.classifications.forEach(classification => {
                    classification.comments = classification.comments.filter(comment => {
                        return comment.id !== commentId;
                    });
                });
            });
            state.comparisonDocuments = comparisonDocuments;
            state.deletingCommentId = undefined;
        },
        [actions.deleteComment.rejected]: (state, action) => {
            var _a;
            state.deletingCommentId = undefined;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
    },
});
export * from './actions';
export const { setIsExportingComparison, setComparisonDocuments, setDocumentComparisonId, } = comparisonSlice.actions;
export default errorWrapper(comparisonSlice.reducer);
